import { Component, OnInit, ElementRef, HostListener, AfterViewInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FilesProvider, FileRaw, ImageReadyService } from './providers/';
import { DomSanitizer, SafeResourceUrl, Title } from '@angular/platform-browser';
import * as PDFJS from "pdfjs-dist";
import { FileClass } from './file.class';

@Component({
  selector: 'file-viewer',
  template: `
    <ng-container *ngIf="fileDataReady" [ngSwitch]="file.type">
      <file-view-image *ngSwitchCase="'image'" [file]="file"></file-view-image>
      <file-view-pdf *ngSwitchCase="'pdf'" [file]="file"></file-view-pdf>
      <file-view-video-native *ngSwitchCase="'nativevideo'" [file]="file"></file-view-video-native>
      <file-view-3d *ngSwitchCase="'threeds'" [file]="file"></file-view-3d>
      <file-view-unknown *ngSwitchDefault [file]="file"></file-view-unknown>
    </ng-container>
  `
})
export class FileViewerComponent implements OnInit {
  file: FileClass;
  showLoading: boolean = false;
  fileDataReady: boolean = false;
  constructor(public ar: ActivatedRoute, public fp: FilesProvider,
    private pageTitle: Title, private san: DomSanitizer) {

    }

  ngOnInit() {
    this.ar.params.subscribe(params => {
      let id = params['id'];
      this.fp.getFileData(id).subscribe((filedata: any) => {
        if(filedata.error) {
          return false;
        }
        let file = filedata.file;
        let locFile = file.file2 ? file.file2 : file.file;
        this.file = new FileClass(file.encryptedID, file.name, locFile, file.mime)
        this.pageTitle.setTitle(this.file.name);
        this.fileDataReady = true;
      });
    });

  }
}



// WEBPACK FOOTER //
// ./src/app/files.view.component.ts